import { render, staticRenderFns } from "./workshops.vue?vue&type=template&id=7e994a0a&scoped=true"
import script from "./workshops.vue?vue&type=script&lang=js"
export * from "./workshops.vue?vue&type=script&lang=js"
import style0 from "./workshops.vue?vue&type=style&index=0&id=7e994a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e994a0a",
  null
  
)

export default component.exports